<section class="up">
  <!-- Always present, so reading and its outcome are announced. -->
  <p class="bk-sr-only" role="status">{{ readStatus }}</p>
  <input
    #fileInput
    type="file"
    id="csvUpload"
    class="bk-sr-only"
    tabindex="-1"
    (change)="onFileSelected($event)"
    [accept]="acceptedFormats"
  />

  <!-- Drop area: drag a file here, or choose one -->
  <div
    class="up__drop"
    [class.is-hovering]="isHovering"
    [class.has-file]="hasFile"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    @if (loading) {
      <span class="bk-sym up__icon" aria-hidden="true">hourglass_top</span>
      <p class="up__title">Reading {{ fileName }}…</p>
      <p class="up__hint">Large files take a few seconds.</p>
    } @else if (hasFile) {
      <span class="bk-sym up__icon" aria-hidden="true">description</span>
      <p class="up__title">{{ fileName }}</p>
      <p class="up__hint">
        {{ formatCount(tableData.length) }} {{ tableData.length === 1 ? 'contact row' : 'contact rows' }} ·
        {{ tableHeaders.length }} {{ tableHeaders.length === 1 ? 'column' : 'columns' }}
      </p>
      <div class="up__actions">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="fileInput.click()">Choose another file</button>
        <button type="button" class="bk-btn bk-btn--primary" (click)="continue()">
          Match columns
          <span class="bk-sym up__next" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    } @else {
      <span class="bk-sym up__icon" aria-hidden="true">upload_file</span>
      <p class="up__title">Drop a CSV or Excel file here</p>
      <p class="up__hint">The first row should hold the column names. .csv, .xls and .xlsx work.</p>
      <div class="up__actions">
        <button type="button" class="bk-btn bk-btn--primary" (click)="fileInput.click()">Choose file</button>
      </div>
    }
  </div>

  @if (errorMsg) {
    <p class="up__error" role="alert">
      <span class="bk-sym" aria-hidden="true">error</span>
      {{ errorMsg }}
    </p>
  }

  <!-- First rows, to check the file before mapping -->
  @if (hasFile) {
    <div class="up__preview">
      <h2 class="bk-section-title">First {{ previewRows.length }} {{ previewRows.length === 1 ? 'row' : 'rows' }}</h2>
      <div class="bk-panel up__table-wrap">
        <table class="bk-log up__table">
          <thead>
            <tr>
              @for (header of tableHeaders; track $index) {
                <th scope="col">{{ header || 'Column ' + ($index + 1) }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of previewRows; track $index) {
              <tr>
                @for (header of tableHeaders; track $index; let col = $index) {
                  <td>{{ row[col] || '—' }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <!-- Template and way out -->
  <div class="up__foot">
    <a class="bk-more up__template" href="/files/blackkonnect-template.csv" download>
      Download the import template
      <span class="bk-sym" aria-hidden="true">download</span>
    </a>
    <button type="button" class="bk-more" (click)="close()">Cancel import</button>
  </div>
</section>
